/**
 * This will compute the derived value for the estimated minimum annual ink cost
 */
import { createSelector } from 'reselect'
import data from '../data'

const getPlanId = (state, props) => state.selectedPlan.id;
const getPlanPages = (state, props) => state.selectedPlan.pages;
const getGenericInk = (state, props) => state.genericInk;
const getHighYield = (state, props) => state.highYieldInk;
const getSelectedPrinter = (state, props) => data.printers.reduce((acc, printer) => {
    if (printer.id === state.selectedPrinter) {
        acc = printer;
    }

    return acc;
}, null);
const getInks = (state, props) => data.inks;

const getMinimumAnnualCost = createSelector(
    [getPlanId, getPlanPages, getSelectedPrinter, getInks, getHighYield, getGenericInk],
    (planId, planPages, printer, inks, highYield, genericInk) => {
        const hydratedInks = printer.inks.map((inkId) => inks.filter((ink) => ink.id === inkId)[0]);
        const printerInks = hydratedInks.filter((ink) => {
            return (ink.high_yield === highYield)
        }).filter((ink) => {
            return (ink.generic === genericInk)
        });

        //-- Use the current plan selected get the total of pages per year to print
        const pagesPerYear = planPages * 12;

        const totalInks = printerInks.length;
        //-- Okay how many ink cartridges will it take to provide the count?
        const totalPage = printerInks.reduce(((acc, ink) => acc + ink.pages), 0);
        const totalCost = printerInks.reduce(((acc, ink) => acc + ink.cost), 0);
        const avgPagesPerCartridge = Math.ceil(totalPage / totalInks);
        const avgCostPerCartridge = totalCost / printerInks.length;

        //-- Take the total pages per year against the pages per cartridge
        const minimumCost = Math.ceil((pagesPerYear / avgPagesPerCartridge)) * avgCostPerCartridge;


        if (planId === 36) {
            return 40;
        } else if (planId === 1) {
            return 40;
        } else if (planId === 2) {
            return 60;
        } else if (planId === 3) {
            return 120;
        }  else {
            return 260;
        }


        // return Math.round(0.1 * minimumCost) / 0.1;
    }
);

export default getMinimumAnnualCost;
